<template>
  <LayoutCard class="composite-card-data" background="var(--vc-primary)">
    <div class="composite-card-data-header">
      <h3>Données de l'ensemble des bâtiments</h3>
    </div>
    <VueDatePicker
      class="composite-card-savings-datepicker"
      range
      v-model="range"
      placeholder="Selectionnez une date..."
      month-picker
      auto-apply
      locale="fr"
      :format="format"
      @update:model-value="onDateChange"
      hide-input-icon
    />
    <LayoutColumns :columns="4" gap="5px">
      <ChartHomeSavings name="Économie Totale" unit="€" :dataset="store.getEUR" />
      <ChartHomeSavings name="Eau Économisée" unit="m³" :dataset="store.getM3" />
      <ChartHomeSavings name="Énergie Économisée" unit="kWh" :dataset="store.getKWH" />
      <ChartHomeSavings name="CO₂ Évité" unit="kgCO₂" :dataset="store.getCO2" />
    </LayoutColumns>
  </LayoutCard>
</template>

<script setup lang="ts">
import LayoutCard from '@/components/layout/LayoutCard.vue'
import { onMounted, ref } from 'vue'
import ChartHomeSavings from './charts/ChartHomeSavings.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import LayoutColumns from '../layout/LayoutColumns.vue'
import { useDashboardStore } from '@/stores/store_dashboard'
import { getDateStringYMD } from '@/service/service_date'

const store = useDashboardStore()
const range = ref()

function onDateChange(
  range: [{ month: number; year: number }, { month: number; year: number }] | null
) {
  if (range === null) {
    store.fetch()
    return
  }

  const start = new Date(range[0].year, range[0].month, 1)
  const end = new Date(range[1].year, range[1].month + 1, 0)
  store.fetch({ start: getDateStringYMD(start), end: getDateStringYMD(end) })
}

onMounted(() => {
  store.fetch()
})

function format(date: Date[]) {
  const start = date[0].toLocaleDateString('fr', { day: undefined, month: 'long', year: 'numeric' })
  if (date[1] && date[1].getMonth() != date[0].getMonth()) {
    const end = date[1].toLocaleDateString('fr', {
      day: undefined,
      month: 'long',
      year: 'numeric'
    })
    return `Période : ${capitalizeFirstLetter(start)} - ${capitalizeFirstLetter(end)}`
  }

  return `Période : ${capitalizeFirstLetter(start)}`
}

function capitalizeFirstLetter(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1)
}
</script>

<style scoped lang="scss">
@import '@/assets/mixins.scss';
.composite-card-data {
  @include vlayout(20px);
  &-header {
    text-align: center;
    color: var(--vc-white);

    &.text-center {
      justify-content: center;
    }

    &-icon {
      width: 36px;
      height: 36px;
      background-color: var(--vc-secondary);
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--vc-white);

      img {
        width: 24px;
      }
    }
  }

  .charts-container {
    display: flex;
    gap: var(--spacer-0_5);
  }
}

.mobile,
.tablet {
  .composite-card-data {
    .charts-container {
      flex-direction: column;
    }
  }
}
</style>

<style lang="scss">
.composite-card-savings-datepicker .dp__input_wrap > input {
  height: 60px;
  border: 1px;
  padding: 20px;
  border-radius: 60px;
  font-weight: 800;
  background-color: #ffffff1a;
  border: 1px solid #ffffff4d;
  color: white;

  &::placeholder {
    color: var(--vc-white);
  }
}
</style>
